import attendeesService from '@/services/attendeesService'

const state = {
  advancedSearch: {
    _id: '',
    document: '',
    eventId: ''
  },
  attendees: [],
  loadingAttendees: true,
  paginationAttendees: {},
  totalAttendees: 0,
  search: ''
}
const mutations = {
  'SET_CATEGORIES' (state, categories) {
    state.categories = categories
  },
  'SET_ATTENDESS' (state, attendees) {
    state.attendees = attendees
  },
  'SET_LOADING_ATTENDEES' (state, status) {
    state.loadingAttendees = status
  },
  'SET_PAGINATION_ATTENDEES' (state, pagination) {
    state.paginationAttendees = pagination
  },
  'SET_SEARCH_ATTENDEES' (state, search) {
    state.search = search
  },
  'SET_TOTAL_ATTENDEES' (state, totalAttendees) {
    state.totalAttendees = totalAttendees
  }
}

const actions = {
  createAttendee (vuexContext, { attendees, eventId, price, ticketId }) {
    return new Promise((resolve, reject) => {
      attendeesService.createAttendee(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        { attendees, eventId, price, ticketId })
        .then(() => {
          vuexContext.dispatch('getAttendees')
          resolve(true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAttendeeInfo (vuexContext, { eventId, attendeeId }) {
    return new Promise((resolve, reject) => {
      attendeesService.getAttendeeInfo(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        eventId,
        attendeeId
      ).then(response => {
        resolve(response.attendee)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAttendees (vuexContext) {
    vuexContext.commit('SET_LOADING_ATTENDEES', true)
    attendeesService.getAttendees(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      vuexContext.state.paginationAttendees,
      vuexContext.state.search,
      vuexContext.state.advancedSearch
    ).then(response => {
      vuexContext.commit('SET_TOTAL_ATTENDEES', response.attendees.count)
      vuexContext.commit('SET_ATTENDESS', response.attendees.rows)
      vuexContext.commit('SET_LOADING_ATTENDEES', false)
    }).catch(() => {
      vuexContext.commit('SET_ATTENDESS', [])
      vuexContext.commit('SET_LOADING_ATTENDEES', false)
    })
  },
  sendAttendeesSms (vuexContext, message) {
    const filters = {
      ...vuexContext.state.advancedSearch,
      search: vuexContext.state.search
    }
    return new Promise((resolve, reject) => {
      attendeesService.sendSms(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        message,
        filters)
        .then(response => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
